import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import Button from 'ati-ui-react/components/Button';
import { useStores } from 'hooks/useStores';
import { addMetric } from 'utils/addMetrics';

import { FavoritesButtonStyles } from './FavoritesButtonStyles';
import Icon from './icons/Icon';

const FavoritesButton = observer(({ advert, mobile = false, className }) => {
  const [state, setState] = useState(advert?.is_favorite ? 'added' : 'add');
  const [isHovered, setHovered] = useState(false);
  const [clicked, setClicked] = useState(false);
  const {
    favoritesStore: {
      addFavorites,
      deleteFavorites,
      setPopoverHintFavoriteVisible,
      localFavoritesID,
      statusAddingFavorites,
      requestFavoritesID,
    },
    profileStore: { isUser },
    popupStore: { openLoginPopup },
    cabinetPageStore: { getMyFavoritesAdverts, getAdvertsCount },
    advertsStore,
  } = useStores();

  const isLoading = requestFavoritesID.includes(advert._id);

  useEffect(() => {
    if (clicked) {
      if (localFavoritesID.includes(advert._id)) {
        setState('added');
      } else {
        setState('add');
      }
    }
  }, [localFavoritesID]);

  useEffect(() => {
    return () => setPopoverHintFavoriteVisible(false);
  }, []);

  if (advert?.is_owner) return null;

  const texts = {
    add: 'В избранное',
    added: 'В избранном',
    remove: 'Из избранного',
  };

  const getText = () => {
    if (isHovered && state === 'added') {
      return texts.remove;
    }
    return texts[state];
  };

  const deleteCallback = async () => {
    if (advert?.isCabinet) {
      await getMyFavoritesAdverts();
      await getAdvertsCount();
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    advertsStore.setMiniCardAnimation(true);
    setClicked(true);
    if (!isUser) {
      openLoginPopup();
    } else if (state === 'add') {
      addFavorites(advert._id)
        .then(() => {
          if (
            statusAddingFavorites.isSuccess &&
            !window.localStorage.getItem('hint-favorite-popover')
          ) {
            setPopoverHintFavoriteVisible(true);
          }
          return null;
        })
        .catch(() => {});
      addMetric('favorites-like');
    } else {
      deleteFavorites(advert._id, deleteCallback);
      addMetric('favorites-unlike');
    }
  };

  const handleMouseEnter = () => setHovered(true);
  const handleMouseLeave = () => setHovered(false);

  return (
    <FavoritesButtonStyles
      className={cn(className, cn({ mobile }))}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Icon className={cn(`icon ${state}`, isLoading && 'loading')} type={state} />
      <Button className="text" size="small" simpleDashed>
        {getText()}
      </Button>
    </FavoritesButtonStyles>
  );
});

export default FavoritesButton;
